import axios from "axios"

class Journal {
	constructor() {
		if (document.querySelector("#journal")) {
			axios.defaults.headers.common["X-WP-Nonce"] = academyData.nonce
			this.allTextareas = document.getElementById("journal").getElementsByClassName("required sm-form-control");
			this.energyLevel = document.getElementById("energy-level");
			this.energyOutput = document.getElementById("level");
			this.dataContainer = document.getElementById("data-container");
			this.navContainer = document.getElementById("journal").querySelector(".journal-navs");
			this.navButtons = document.getElementById("journal").querySelector(".journal-navs").querySelectorAll(".j-nav");
			this.previousValue = []
    		this.typingTimer = []

			this.events();
		}
	}

	events() {
		for (let i = 0; i < this.allTextareas.length; i++) {
			this.allTextareas[i].addEventListener("keyup", () => this.typingLogic());
		}
		this.navContainer.addEventListener("click", e => this.clickHandler(e));
		this.energyLevel.oninput = () => this.energySlider();
	}

	clickHandler(e) {
        if (e.target.classList.contains("j-nav")) this.loadValues(e);
    }

	typingLogic() {
		for (let i = 0; i < this.allTextareas.length; i++) {
			if (this.allTextareas[i].value !== this.previousValue[i]) {
				clearTimeout(this.typingTimer[i]);
					
				if (this.allTextareas[i].value) {
					this.typingTimer[i] = setTimeout(() => {
						this.saveValues(i, this.allTextareas[i].value);
					}, 1000);
				}
			}
				
			this.previousValue[i] = this.allTextareas[i].value;
		}
	}

	async saveValues(index, value) {
		try {
			const journalDateString = this.dataContainer.dataset.journalDate;
			const journalYear = parseInt(journalDateString.substring(0, 4));
			const journalMonth = parseInt(journalDateString.substring(4, 6));
			const journalDay = parseInt(journalDateString.substring(6, 8));
			
			const journalData = {};

			if (!(journalYear in journalData)) {
				journalData[journalYear] = {};
			}
			
			if (!(journalMonth in journalData[journalYear])) {
				journalData[journalYear][journalMonth] = {};
			}
			
			if (!(journalDay in journalData[journalYear][journalMonth])) {
				journalData[journalYear][journalMonth][journalDay] = {};
			}
		
			journalData[journalYear][journalMonth][journalDay][index] = value;

			await axios.post(academyData.root_url + "/wp-json/academy/v1/manage-journal", { "values": journalData });
		} catch (e) {
			console.log(e);
		}
	}

	async loadValues(e) {
		if (!e.target.classList.contains("j-nav-active")) {
			try {
				for (let nav = 0; nav < this.navButtons.length; nav++) {
					if (this.navButtons[nav].classList.contains("j-nav-active")) {
						this.navButtons[nav].classList.remove("j-nav-active");
					}
				}

				e.target.classList.add("j-nav-active");

				for (let i = 0; i < this.allTextareas.length; i++) {
					this.allTextareas[i].value = '';
					this.energyLevel.value = 0;
					this.energyOutput.innerHTML = 0;
				}
	
				const journalDate = e.target.dataset.journalDate;
				const response = await axios.post(academyData.root_url + "/wp-json/academy/v1/get-journal", { "date": journalDate });
				const results = response.data;
	
				if (results) {
					Object.entries(results).forEach(([key, value]) => {
						if (key < 6) {
							this.allTextareas[key].value = value;
						} else {
							this.energyLevel.value = value;
							this.energyOutput.innerHTML = value;
						}
					});
				}
	
				this.dataContainer.setAttribute("data-journal-date", journalDate);
			} catch (e) {
				console.log(e);
			}
		}
	}

	energySlider() {
		this.saveValues(6, this.energyLevel.value)
		this.energyOutput.innerHTML = this.energyLevel.value;
	}
}

export default Journal;
